import React from "react";
import { useApp } from "@/context/AppContext";
import { LEGAL } from "@/data/legal";

export default function LegalPage({ pageKey }) {
  const { lang } = useApp();
  const data = LEGAL[pageKey][lang];
  return (
    <div className="mx-auto max-w-3xl px-6 py-16 sm:px-8" data-testid={`legal-${pageKey}`}>
      <h1 className="text-4xl font-extrabold tracking-tighter text-cea-ink sm:text-5xl">{data.title}</h1>
      <div className="mt-10 space-y-8">
        {data.sections.map((s, i) => (
          <section key={i} data-testid={`legal-section-${pageKey}-${i}`}>
            <h2 className="text-lg font-bold text-cea-navy">{s.h}</h2>
            <p className="mt-2 leading-relaxed text-slate-600">{s.p}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
